module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box"
  }, [_c('p', {
    staticClass: "btn1 btn",
    style: ({
      'background-color': _vm.color
    })
  }), _vm._v(" "), _c('p', {
    staticClass: "btn2 btn",
    style: ({
      'background-color': _vm.color
    })
  }), _vm._v(" "), _c('p', [_vm._v(_vm._s(_vm.name))]), _vm._v(" "), _c('p', {
    staticClass: "btn2 btn",
    style: ({
      'background-color': _vm.color
    })
  }), _vm._v(" "), _c('p', {
    staticClass: "btn1 btn",
    style: ({
      'background-color': _vm.color
    })
  })])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2ed74d7c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/tpl1/secondTitle/secondTitle.vue
// module id = 786
// module chunks = 10